<script lang="ts">
	import { ArrowForward } from "luxedo-icons"
	import type { Step } from "./types"
	import { Responsive } from "responsive"

	interface Props {
		step: Step
		stepNumber: number
		onclick?: () => void
		active?: boolean
		hideArrow?: boolean
	}

	let { step, active, onclick, stepNumber, hideArrow }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)
</script>

<div
	role="button"
	tabindex="0"
	onclick={onclick ? () => onclick() : undefined}
	onkeydown={onclick ? (e) => (e.key === "Enter" ? onclick() : null) : undefined}
	class="step"
	class:active
	class:isMobile
>
	<span class="step-number">
		{stepNumber}
	</span>
	<div class="step-text">
		{#if step.title}
			<h3>{step.title}</h3>
		{/if}
		{step.description}
		{#if active && !hideArrow}
			<ArrowForward />
		{/if}
	</div>
</div>

<style>
	.step {
		cursor: default;
		margin-bottom: 1rem;
		display: flex;
		flex-direction: row;
		color: var(--color-text);
		align-items: center;
		min-height: 3rem;
	}

	.step-number {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 2.5rem;
		height: 2.5rem;
		border: 1px solid var(--color-text);
		color: var(--color-text-light);

		border-radius: 99px;
		margin-right: 1rem;
		padding-bottom: 0.5rem;
		font-size: 2rem;
	}

	.step-text {
		position: relative;
		font-size: var(--h3);
		padding-right: 1.5rem;
		margin-right: 1rem;
		padding-top: calc(var(--h1) - var(--h2));
		width: calc(100% - 5rem);
		line-height: 1em;
	}

	.step.active {
		color: var(--color-main);
	}

	.step.active .step-text h3 {
		color: var(--color-main);
		font-size: var(--h1);
	}

	.step.active .step-text {
		color: var(--color-text-light);
		padding-top: 0;
	}

	.isMobile .step-number {
		width: 2rem;
		height: 2rem;
		font-size: var(--h1);
	}

	.isMobile.step.active .step-text h3 {
		font-size: var(--h2);
	}

	.isMobile.step .step-text {
		font-size: var(--h3);
	}

	.isMobile.step {
		margin-bottom: 0.5rem;
	}

	@keyframes arrowAnim {
		0% {
			transform: translateX(-400%);
		}

		100% {
			transform: translateX(0%);
		}
	}

	.step-text :global(svg) {
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		margin-top: auto;
		margin-bottom: auto;
		width: 1rem;
		overflow: hidden;
	}

	.step-text :global(svg > path) {
		animation: arrowAnim;
		animation-duration: 250ms;
	}

	.step-text :global(.svg-stroke) {
		stroke: var(--color-main);
	}

	.step-text h3 {
		margin: 0;
		font-size: var(--h2);
		line-height: 1em;
		padding-bottom: 0.5rem;
	}

	.step-number,
	.step-text h3,
	.step-text {
		transition:
			color 250ms,
			font-size 250ms,
			border-color 250ms,
			padding 250ms;
	}

	.step.active .step-number {
		color: var(--color-main);
	}

	@media only screen and (max-height: 768px) {
		.step {
			margin-bottom: 0.5rem;
		}

		.step-number {
			width: 2rem;
			height: 2rem;
			vertical-align: center;
			font-size: var(--h2);
		}

		.step .step-text h3,
		.step.active .step-text h3 {
			font-size: var(--h2);
		}

		.isMobile .step.active .step-text h3 {
			font-size: var(--h3);
		}
	}
</style>
